import { User, Product, Notification, Service } from "@/types";

// Étendre l'utilisateur mock pour inclure username/password
export type MockUser = User & { username: string; password: string };

export const mockUsers: MockUser[] = [
  {
    id: "1",
    username: "admin",
    password: "admin123",
    firstName: "Jean",
    lastName: "Dupont",
    email: "jean.dupont@example.com",
    service: "IT",
    role: "admin",
    isActive: true,
    createdAt: "2024-01-15T08:00:00Z"
  },
  {
    id: "2",
    username: "superadmin",
    password: "superpass",
    firstName: "Marie",
    lastName: "Martin",
    email: "marie.martin@example.com",
    service: "Marketing",
    role: "admin",
    isActive: true,
    createdAt: "2024-01-10T09:30:00Z"
  },
  {
    id: "3",
    username: "user1",
    password: "userpass1",
    firstName: "Pierre",
    lastName: "Bernard",
    email: "pierre.bernard@example.com",
    service: "Finance",
    role: "user",
    isActive: false,
    createdAt: "2024-01-05T14:15:00Z"
  },
  {
    id: "4",
    username: "sophieuser",
    password: "sophiepw",
    firstName: "Sophie",
    lastName: "Dubois",
    email: "sophie.dubois@example.com",
    service: "HR",
    role: "user",
    isActive: true,
    createdAt: "2024-01-20T11:45:00Z"
  },
  {
    id: "5",
    username: "thomasadmin",
    password: "thomaspw",
    firstName: "Thomas",
    lastName: "Moreau",
    email: "thomas.moreau@example.com",
    service: "Sales",
    role: "admin",
    isActive: true,
    createdAt: "2024-01-12T16:20:00Z"
  }
];

export const adminCredentials = null; // n'est plus utilisé

export const mockProducts: Product[] = [
  {
    id: "1",
    name: "CRM Pro",
    imagePath: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop",
    description: "Système de gestion de la relation client avancé pour optimiser vos ventes.",
    ipAddress: "192.168.1.100",
    primaryEmail: "admin@crmpro.com",
    secondaryEmails: "support@crmpro.com,sales@crmpro.com",
    licenseStartDate: "2024-01-01T00:00:00Z",
    expirationDate: "2024-12-31T23:59:59Z",
    status: "active",
    createdBy: "1",
    createdAt: "2024-01-01T10:00:00Z"
  },
  {
    id: "2",
    name: "Analytics Dashboard",
    imagePath: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop",
    description: "Tableau de bord analytique pour suivre les performances de votre entreprise.",
    ipAddress: "192.168.1.101",
    primaryEmail: "analytics@dashboard.com",
    secondaryEmails: "admin@dashboard.com",
    licenseStartDate: "2024-02-01T00:00:00Z",
    expirationDate: "2025-01-31T23:59:59Z",
    status: "active",
    createdBy: "2",
    createdAt: "2024-02-01T09:00:00Z"
  },
  {
    id: "3",
    name: "Security Suite",
    imagePath: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=300&fit=crop",
    description: "Suite de sécurité complète pour protéger votre infrastructure IT.",
    ipAddress: "192.168.1.102",
    primaryEmail: "security@suite.com",
    secondaryEmails: "admin@suite.com,support@suite.com",
    licenseStartDate: "2023-12-01T00:00:00Z",
    expirationDate: "2024-01-31T23:59:59Z",
    status: "expired",
    createdBy: "1",
    createdAt: "2023-12-01T08:30:00Z"
  },
  {
    id: "4",
    name: "Project Manager",
    imagePath: "https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=400&h=300&fit=crop",
    description: "Outil de gestion de projets pour améliorer la collaboration d'équipe.",
    ipAddress: "192.168.1.103",
    primaryEmail: "pm@manager.com",
    secondaryEmails: "admin@manager.com",
    licenseStartDate: "2024-03-01T00:00:00Z",
    expirationDate: "2025-02-28T23:59:59Z",
    status: "active",
    createdBy: "2",
    createdAt: "2024-03-01T14:00:00Z"
  },
  {
    id: "5",
    name: "Backup Pro",
    imagePath: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400&h=300&fit=crop",
    description: "Solution de sauvegarde professionnelle pour vos données critiques.",
    ipAddress: "192.168.1.104",
    primaryEmail: "backup@pro.com",
    secondaryEmails: "admin@pro.com,support@pro.com",
    licenseStartDate: "2023-06-01T00:00:00Z",
    expirationDate: "2024-01-15T23:59:59Z",
    status: "expired",
    createdBy: "1",
    createdAt: "2023-06-01T12:00:00Z"
  },
  {
    id: "6",
    name: "Communication Hub",
    imagePath: "https://images.unsplash.com/photo-1577962917302-cd874c4e31d2?w=400&h=300&fit=crop",
    description: "Plateforme de communication unifiée pour votre entreprise.",
    ipAddress: "192.168.1.105",
    primaryEmail: "comm@hub.com",
    secondaryEmails: "admin@hub.com",
    licenseStartDate: "2024-04-01T00:00:00Z",
    expirationDate: "2025-03-31T23:59:59Z",
    status: "active",
    createdBy: "3",
    createdAt: "2024-04-01T15:30:00Z"
  }
];

export const mockNotifications: Notification[] = [
  {
    id: "1",
    userId: "1",
    message: "Votre licence CRM Pro expire dans 30 jours",
    isRead: false,
    createdAt: "2024-01-15T09:00:00Z"
  },
  {
    id: "2",
    userId: "2",
    message: "Nouveau produit Analytics Dashboard ajouté",
    isRead: true,
    createdAt: "2024-01-14T14:30:00Z"
  },
  {
    id: "3",
    userId: "1",
    message: "Licence Security Suite expirée",
    isRead: false,
    createdAt: "2024-02-01T08:00:00Z"
  }
];

export const services: Service[] = ['IT', 'Marketing', 'Finance', 'HR', 'Sales', 'Other'];
